import { RevisionPart } from "../revision/revision-part.model";

export interface Service {
    additionalService: boolean;
    discount: number;
    dmsCode: string;
    isApproved: boolean;
    laborTime: string;
    price: number;
    promotionalPrice: number;
    quotationServiceId: number;
    quotationType: string;
    sequence: number;
    serviceId: number;
    serviceName: string;
    serviceType: string;
    status: string;
    subtotal: number;
    revisionParts: RevisionPart[];
}
